(function(){
var _$settings_3 = {};
"use strict";

Object.defineProperty(_$settings_3, "__esModule", { value: true });
_$settings_3.settings = void 0;
_$settings_3.settings = {
    project: 'WTW.EX.Assets',
    version: '1.0.0',
    translation_version: 'v1.52',
    author: 'Willis Towers Watson',
    company: 'Willis Towers Watson',
    url: 'www.willistowerswatson.com',
    email: 'appx@willistowerswatson.com',
    description: 'WTW.EX.Assets contains the resource files needed for pre-auth and some post-auth user interfaces and user experiences',
    FALLBACK_LANGUAGE: 'en-US',
    legalDocs: {
        basePath: '/docs',
        fileNames: {
            termsOfUse: 'terms-of-use.html',
            cookieNotice: 'cookie-notice.html',
            privacyNotice: 'privacy-notice.html'
        }
    },
    cookieConfigs: {
        commonAuth: {
            domain: 'auth-2.ehr.com',
            appId: 'c881b241-6f27-47c9-b147-f6d7c93e8e6d'
        },
        registration: {
            domain: 'signin-embark.ehr.com',
            appId: '56da48b8-c13b-495e-bdd0-0e87fafc26c9'
        },
        portal: {
            domain: 'embark.ehr.com',
            appId: '732a960c-ec94-4992-ab25-085d34ac38f8'
        }
    },
    logos: {
        helpicon: '/img/icons8-help.svg',
        footer: '/img/wtw_logo_blk.svg',
        header: {
            demoClientLogoPath: '/img/myPortal.png',
            wtwLogoPath: '/img/wtw_logo_purple.svg'
        }
    },
    toastTimeout: 5000
};

var _$environmentDefault_1 = {};
"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(_$environmentDefault_1, "__esModule", { value: true });
_$environmentDefault_1.environment = void 0;
var lodash_merge_1 = __importDefault(require("lodash.merge"));
/* removed: var _$settings_3 = require("./settings"); */;
_$environmentDefault_1.environment = (0, lodash_merge_1.default)({}, _$settings_3.settings, {
    copyrightCorporateName: "WTW",
    defaultCultureCode: "en-us",
    registrationConfigApiUrl: "",
    storageAccountUrl: '',
    storageContainer: '',
    logos: {
        helpicon: "/img/icons8-help.svg",
        footer: "/img/wtw_logo_blk.svg",
        header: {
            demoClientLogoPath: "/img/myPortal.png",
            wtwLogoPath: "/img/wtw_logo_purple.svg"
        },
        alt: 'WTW Logo'
    },
    translationApiUrl: "",
    jiraProxyAPI: "",
    translation: {
        apiUrl: "",
        applicationContextId: 2
    },
    appInsightsConfig: {
        applicationName: 'WTW.EX.Assets',
        version: '1.0.8',
        instrumentationKey: '',
        environmentName: ''
    },
    appInsightsConfigPro: {
        applicationName: 'WTW.EX.Assets',
        version: '1.0.8',
        instrumentationKey: '',
        environmentName: ''
    },
    topLevelDomain: "",
    possibleClientCountryParams: ["clientCountry", "clientCountryId"],
    possibleLanguageParams: ["cultureCode", "ui_locales"],
    legalDoc: {
        urlBase: "/notices",
        fileNames: {
            termsOfUse: "terms-of-use",
            cookieNotice: "cookie-notice",
            privacyNotice: "privacy-notice"
        }
    },
    useTestScripts: true,
    cookieAppIds: {},
    prodDomain: 'ehr.com',
    portalSiteName: 'appx',
    oneTrust: {
        cookieBannerScriptSrc: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
        defaultLanguage: "en"
    },
    registrationPageUrl: "",
    embarkPrivacyNoticePageUrl: "",
    policyNames: {
        B2C_1A_PEX_ChangeMFA: "B2C_1A_PEX_ChangeMFA",
        B2C_1A_PEX_ChangePassword: 'B2C_1A_PEX_ChangePassword',
        B2C_1A_PEX_ChangePhoneNumber: 'B2C_1A_PEX_ChangePhoneNumber',
        B2C_1A_PEX_ChangeSignInName: 'B2C_1A_PEX_ChangeSignInName',
        B2C_1A_PEX_CorpEmail_SignUp: 'B2C_1A_PEX_CorpEmail_SignUp',
        B2C_1A_PEX_ForgotPassword: 'B2C_1A_PEX_ForgotPassword',
        B2C_1A_PEX_SelfIdentification: "B2C_1A_PEX_SelfIdentification",
        B2C_1A_PEX_Signin: 'B2C_1A_PEX_Signin',
        B2C_1A_PEX_SignUp: 'B2C_1A_PEX_SignUp',
        B2C_1A_PEX_SignUpSignIn: "B2C_1A_PEX_SignUpSignIn",
        B2C_1A_PEX_SigninOidc: "B2C_1A_PEX_SigninOidc",
        B2C_1A_SSO_Assertion: 'B2C_1A_WTW_CommonAuthentication',
        B2C_1A_PEX_SignIn2: 'B2C_1A_PEX_SignIn2',
        B2C_1A_PEX_SignUp2: 'B2C_1A_PEX_SignUp2',
        B2C_1A_PEX_ChangeMFABETA: "B2C_1A_PEX_ChangeMFABETA",
        B2C_1A_PEX_ChangePasswordBETA: 'B2C_1A_PEX_ChangePasswordBETA',
        B2C_1A_PEX_ChangePhoneNumberBETA: 'B2C_1A_PEX_ChangePhoneNumberBETA',
        B2C_1A_PEX_ChangeSignInNameBETA: 'B2C_1A_PEX_ChangeSignInNameBETA',
        B2C_1A_PEX_CorpEmail_SignUpBETA: 'B2C_1A_PEX_CorpEmail_SignUpBETA',
        B2C_1A_PEX_ForgotPasswordBETA: 'B2C_1A_PEX_ForgotPasswordBETA',
        B2C_1A_PEX_SelfIdentificationBETA: "B2C_1A_PEX_SelfIdentificationBETA",
        B2C_1A_PEX_SigninBETA: 'B2C_1A_PEX_SigninBETA',
        B2C_1A_PEX_SignUpBETA: 'B2C_1A_PEX_SignUpBETA',
        B2C_1A_PEX_SignUpSignInBETA: "B2C_1A_PEX_SignUpSignInBETA",
        B2C_1A_PEX_SilentReg: "B2C_1A_PEX_SilentReg",
        B2C_1A_PEX_SilentRegBETA: "B2C_1A_PEX_SilentRegBETA",
        B2C_1A_PEX_ChangeAuthenticator: "B2C_1A_PEX_ChangeAuthenticator",
        B2C_1A_PEX_ChangeAuthenticatorBETA: "B2C_1A_PEX_ChangeAuthenticatorBETA"
    },
    cookieBannerSettings: {
        verboseLogging: false,
        oneTrustCheckerIntervalInSeconds: 5
    },
    samlUrl: "https://n21pexsamltestqaappsvc.azurewebsites.net",
    pushNotificationsApiUrl: "https://embarkpro-qa.ehr.com/std-gateway/api/pushnotifications"
});

var _$environment_2 = {};
"use strict";

var ____importDefault_2 = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(_$environment_2, "__esModule", { value: true });
_$environment_2.environment = void 0;
var __lodash_merge_1_2 = ____importDefault_2(require("lodash.merge"));
/* removed: var _$environmentDefault_1 = require("./environment.default"); */;
_$environment_2.environment = (0, __lodash_merge_1_2.default)({}, _$environmentDefault_1.environment, {
    environmentName: "uat-emea",
    storageAccountUrl: 'https://assets-embark-uat-eu.ehr.com',
    storageContainer: '',
    registrationConfigApiUrl: 'https://embark-gw-uat-eu.ehr.com/api/registrationConfig',
    translationApiUrl: 'https://embark-gw-uat-eu.ehr.com/api/Registration/Translation',
    jiraProxyAPI: 'https://embark-gw-uat-eu.ehr.com/api/jira',
    registrationApi: "https://embark-gw-uat-eu.ehr.com/api/Registration",
    configurationApiUrl: "https://embark-gw-uat-eu.ehr.com/api/config",
    signUpUrl: {
        signUpBaseUrl: "https://signin-embark-uat-eu.ehr.com",
        redirectUrl: "https://auth-2-uat.ehr.com/wtwb2cuateu.onmicrosoft.com/oauth2/authresp"
    },
    translation: {
        apiUrl: "https://translations-service-uat-eu.willistowerswatson.com/api",
        applicationContextId: 2
    },
    appInsightsConfig: {
        instrumentationKey: '62341ccf-0f1f-40e1-a66e-660181d3fb61',
        environmentName: 'uat'
    },
    appInsightsConfigPro: {
        instrumentationKey: '66d2060f-a371-427e-89b2-2771d2547a03',
        environmentName: 'AzUATEM'
    },
    useTestScripts: true,
    cookieAppIds: {
        commonAuth: 'e5277f8a-ac5a-4cc7-b6ac-dd4bacd52049',
        registration: 'e5277f8a-ac5a-4cc7-b6ac-dd4bacd52049',
        portal: '79f3ee7c-787e-4121-9c05-b35b99548c92'
    },
    topLevelDomain: "ehr.com",
    portalSiteName: 'embark',
    registrationPageUrl: "https://signin-embark-uat-eu.ehr.com",
    embarkPrivacyNoticePageUrl: "https://signin-embark-uat-eu.ehr.com/notices/privacy-notice",
    policyNames: {
        B2C_1A_PEX_ChangePassword: 'B2C_1A_PEX_ChangePassword',
        B2C_1A_PEX_ChangePhoneNumber: 'B2C_1A_PEX_ChangePhoneNumber',
        B2C_1A_PEX_ChangeSignInName: 'B2C_1A_PEX_ChangeSignInName',
        B2C_1A_PEX_CorpEmail_SignUp: 'B2C_1A_PEX_CorpEmail_SignUp',
        B2C_1A_PEX_ForgotPassword: 'B2C_1A_PEX_ForgotPassword',
        B2C_1A_PEX_Signin: 'B2C_1A_PEX_Signin',
        B2C_1A_PEX_SignUp: 'B2C_1A_PEX_SignUp',
        B2C_1A_SSO_Assertion: 'B2C_1A_WTW_CommonAuthentication',
        B2C_1A_PEX_SignUpSignInBeta: "B2C_1A_PEX_SignUpSignInBETA",
        B2C_1A_PEX_SelfIdentification: "B2C_1A_PEX_SelfIdentification",
        B2C_1A_PEX_SigninOidc: "B2C_1A_PEX_SigninOidc",
        B2C_1A_PEX_ChangeMFA: "B2C_1A_PEX_ChangeMFA",
        B2C_1A_PEX_SignIn2: 'B2C_1A_PEX_SignIn2',
        B2C_1A_PEX_SignUp2: 'B2C_1A_PEX_SignUp2',
        B2C_1A_PEX_SignUpSignIn: 'B2C_1A_PEX_SignUpSignIn'
    },
    cookieBannerSettings: {
        verboseLogging: false,
        oneTrustCheckerIntervalInSeconds: 5
    },
    samlUrl: "https://n21pexsamltestuatappsvc.azurewebsites.net",
    pushNotificationsApiUrl: "https://embark-gw-uat-eu.ehr.com/api/pushnotifications",
    loginUrl: "https://signin-embark-uat-eu.ehr.com/login",
    EnabledSessionTranslation: true,
    SessionTranslationKey: 'translationKey_',
    SessionTranslationTimeOut: 10080
});

var _$domainEnum_7 = {};
"use strict";

Object.defineProperty(_$domainEnum_7, "__esModule", { value: true });
_$domainEnum_7.Domain = void 0;
var Domain;
(function (Domain) {
    Domain[Domain["Registration"] = 0] = "Registration";
    Domain[Domain["Main"] = 1] = "Main";
    Domain[Domain["B2C"] = 2] = "B2C";
    Domain[Domain["Embark2"] = 3] = "Embark2";
})(Domain = _$domainEnum_7.Domain || (_$domainEnum_7.Domain = {}));

var _$commonHelper_8 = {};
"use strict";

var ____importDefault_8 = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(_$commonHelper_8, "__esModule", { value: true });
_$commonHelper_8.getCancelRedirectUri = _$commonHelper_8.getQueryParamFromRawUrl = _$commonHelper_8.getQueryParamFromRaw = _$commonHelper_8.validateEmail = _$commonHelper_8.waitUntilTrue = _$commonHelper_8.caseInsensitiveArrayIncludes = _$commonHelper_8.caseInsensitiveStringCompare = _$commonHelper_8.getCurrentDomain = _$commonHelper_8.getDeviceType = _$commonHelper_8.extractEmailInString = _$commonHelper_8.setNewUrlQueryParam = _$commonHelper_8.getQueryParam = _$commonHelper_8.windowSettings = _$commonHelper_8.getCultureInfoFromPage = _$commonHelper_8.waitForElementToLoad = _$commonHelper_8.stringToEnumValue = _$commonHelper_8.inIframe = _$commonHelper_8.loadPolyfillsIfNeeded = _$commonHelper_8.loadScript = void 0;
var device_detector_js_1 = ____importDefault_8(require("device-detector-js"));
/* removed: var _$environment_2 = require("../../environments/environment"); */;
/* removed: var _$domainEnum_7 = require("../enums/domain.enum"); */;
var loadScript = function loadScript(src, doneCallback) {
    if (doneCallback === void 0) {
        doneCallback = null;
    }
    if (!!!doneCallback) doneCallback = function doneCallback() {};
    if (isTheScriptAlreadyLoaded(src)) {
        doneCallback();
        return;
    }
    var js = document.createElement("script");
    js.src = src;
    js.onload = function () {
        addScriptToLoadedScripts(src);
        doneCallback();
    };
    js.onerror = function () {
        doneCallback(new Error("Failed to load script " + src));
    };
    document.head.appendChild(js);
};
_$commonHelper_8.loadScript = loadScript;
var loadPolyfillsIfNeeded = function loadPolyfillsIfNeeded(doneCallback) {
    if (!!!window.fetch || !!!window.Promise) {
        var polyfillPackageUrl = "".concat(_$environment_2.environment.storageAccountUrl).concat(_$environment_2.environment.storageContainer, "/js/polyfills.js");
        (0, _$commonHelper_8.loadScript)(polyfillPackageUrl, function () {
            doneCallback();
        });
    } else {
        doneCallback();
    }
};
_$commonHelper_8.loadPolyfillsIfNeeded = loadPolyfillsIfNeeded;
var inIframe = function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
_$commonHelper_8.inIframe = inIframe;
var addScriptToLoadedScripts = function addScriptToLoadedScripts(src) {
    window.loadedScripts = (window.loadedScripts || []).concat(src.toLocaleLowerCase());
};
var isTheScriptAlreadyLoaded = function isTheScriptAlreadyLoaded(src) {
    return (window.loadedScripts || []).indexOf(src.toLocaleLowerCase()) > -1;
};
var stringToEnumValue = function stringToEnumValue(enumObj, value) {
    var enumKey = Object.keys(enumObj).filter(function (k) {
        return enumObj[k].toString() === value;
    })[0];
    return enumObj[enumKey];
};
_$commonHelper_8.stringToEnumValue = stringToEnumValue;
var waitForElementToLoad = function waitForElementToLoad(elementSelector, loadDoneCallback) {
    var retryMsDelay = 100;
    var retryCount = 100;
    var retries = 0;
    var interval = setInterval(function () {
        retries++;
        if ($(elementSelector).length > 0) {
            var el = $(elementSelector);
            clearInterval(interval);
            console.debug("".concat(elementSelector, " found after ").concat(retries, " retries!"));
            loadDoneCallback(el);
        }
        if (retries === retryCount) {
            console.warn("".concat(elementSelector, " not found after ").concat(retries, " retries..."));
            clearInterval(interval);
        }
    }, retryMsDelay);
};
_$commonHelper_8.waitForElementToLoad = waitForElementToLoad;
var getCultureInfoFromPage = function getCultureInfoFromPage() {
    var cultureCode = "";
    var language = "en";
    var country = "us";
    if (window && window.SETTINGS) {
        if (window.SETTINGS.locale.lang) {
            if (window.SETTINGS.locale.country) {
                language = window.SETTINGS.locale.lang.toLowerCase();
                country = window.SETTINGS.locale.country.toLowerCase();
                cultureCode = "".concat(language, "-").concat(country);
            } else {
                language = window.SETTINGS.locale.lang.toLowerCase();
                cultureCode = sessionStorage.getItem('cultureCode');
                console.debug("scripts > translationservice.js > langCode: ", cultureCode);
            }
        }
    }
    return { cultureCode: cultureCode, language: language, country: country };
};
_$commonHelper_8.getCultureInfoFromPage = getCultureInfoFromPage;
var windowSettings = function windowSettings() {
    var _a;return (_a = window && window["SETTINGS"]) !== null && _a !== void 0 ? _a : {};
};
_$commonHelper_8.windowSettings = windowSettings;
var getQueryParam = function getQueryParam(name, url) {
    if (url === void 0) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"), "i"),
        results = regex.exec(url);
    if (!results || !results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
_$commonHelper_8.getQueryParam = getQueryParam;
var setNewUrlQueryParam = function setNewUrlQueryParam(queryparam, newvalue, currentUrl) {
    if (currentUrl === void 0) {
        currentUrl = window.location.href;
    }
    var url = new URL(currentUrl);
    url.searchParams.set(queryparam, newvalue);
    return url.href;
};
_$commonHelper_8.setNewUrlQueryParam = setNewUrlQueryParam;
var extractEmailInString = function extractEmailInString(s) {
    if (!s) return [];
    var emailRegex = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi;
    return s.match(emailRegex);
};
_$commonHelper_8.extractEmailInString = extractEmailInString;
var deviceType;
var getDeviceType = function getDeviceType() {
    if (deviceType) return deviceType;
    var userAgent = navigator.userAgent;
    var deviceInfo = new device_detector_js_1.default().parse(userAgent);
    console.debug("[common.helper::getDeviceType] deviceInfo", deviceInfo);
    var type;
    switch (deviceInfo.device.type.toString()) {
        case "desktop":
            type = "Desktop";
            break;
        case "smartphone":
            type = "Mobile";
            break;
        case "tablet":
            type = "Tablet";
            break;
        case "phablet":
            type = "Phablet";
            break;
        case "":
            switch (true) {
                case /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent):
                    type = "Mobile";
                    break;
                case /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent.toLowerCase()):
                    type = "Tablet";
                    break;
                default:
                    type = "Others";
                    break;
            }
            break;
        default:
            type = "Others";
    }
    console.debug("[common.helper::getDeviceType] type", type);
    return deviceType = type;
};
_$commonHelper_8.getDeviceType = getDeviceType;
var currentDomain;
var getCurrentDomain = function getCurrentDomain() {
    if (currentDomain) return currentDomain;
    var domain;
    switch (true) {
        case !!window["SETTINGS"]:
            domain = _$domainEnum_7.Domain.B2C;
            break;
        case !!window["SharedComponentsWidget"]:
            domain = _$domainEnum_7.Domain.Main;
            break;
        case !!window["Domain"] && window["Domain"] === "Registration":
            domain = _$domainEnum_7.Domain.Registration;
            break;
        default:
            domain = _$domainEnum_7.Domain.Embark2;
    }
    return currentDomain = domain;
};
_$commonHelper_8.getCurrentDomain = getCurrentDomain;
var caseInsensitiveStringCompare = function caseInsensitiveStringCompare(s1, s2) {
    var _a, _b;
    return ((_a = s1 === null || s1 === void 0 ? void 0 : s1.toLocaleUpperCase()) !== null && _a !== void 0 ? _a : "") === ((_b = s2 === null || s2 === void 0 ? void 0 : s2.toLocaleUpperCase()) !== null && _b !== void 0 ? _b : "");
};
_$commonHelper_8.caseInsensitiveStringCompare = caseInsensitiveStringCompare;
var caseInsensitiveArrayIncludes = function caseInsensitiveArrayIncludes(arr, s) {
    var _a, _b;
    s = (_a = s === null || s === void 0 ? void 0 : s.toLocaleUpperCase()) !== null && _a !== void 0 ? _a : "";
    return (_b = arr === null || arr === void 0 ? void 0 : arr.some(function (x) {
        return x.toLocaleUpperCase() === s;
    })) !== null && _b !== void 0 ? _b : false;
};
_$commonHelper_8.caseInsensitiveArrayIncludes = caseInsensitiveArrayIncludes;
var waitUntilTrue = function waitUntilTrue(conditionCallback, callback) {
    var retryMsDelay = 100;
    var retryCount = 60;
    var retries = 0;
    var interval = setInterval(function () {
        retries++;
        if (!!conditionCallback()) {
            clearInterval(interval);
            console.debug("[CommonHelper:waitUntilTrue] conditionCallback passed after ".concat(retries, " retries!"));
            callback();
        }
        if (retries === retryCount) {
            console.debug("[CommonHelper:waitUntilTrue] conditionCallback didn't pass after ".concat(retries, " retries..."));
            clearInterval(interval);
        }
    }, retryMsDelay);
};
_$commonHelper_8.waitUntilTrue = waitUntilTrue;
var validateEmail = function validateEmail(email) {
    var emailReg = /^([\w-\.]+)@@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return emailReg.test(email);
};
_$commonHelper_8.validateEmail = validateEmail;
function getQueryParamFromRaw(raw, param, where) {
    var _a;
    if (where === void 0) {
        where = "auto";
    }
    if (typeof raw !== "string" || !raw) return null;
    var hashIndex = raw.indexOf("#");
    var queryPart = hashIndex === -1 ? raw : raw.slice(0, hashIndex);
    var fragmentPart = hashIndex === -1 ? "" : raw.slice(hashIndex + 1);
    var readParam = function readParam(s) {
        if (!s) return null;
        var normalized = s.startsWith("?") ? s.slice(1) : s;
        var params = new URLSearchParams(normalized);
        return params.has(param) ? params.get(param) : null;
    };
    if (where === "query") return readParam(queryPart);
    if (where === "fragment") return readParam(fragmentPart);
    return (_a = readParam(queryPart)) !== null && _a !== void 0 ? _a : readParam(fragmentPart);
}
_$commonHelper_8.getQueryParamFromRaw = getQueryParamFromRaw;
function getQueryParamFromRawUrl(raw, param, where) {
    if (where === void 0) {
        where = "auto";
    }
    if (typeof raw !== "string" || !raw) return null;
    try {
        var url_1 = new URL(raw);
        var queryVal = url_1.searchParams.get(param);
        var fragmentVal = function () {
            var frag = url_1.hash.startsWith("#") ? url_1.hash.slice(1) : url_1.hash;
            var params = new URLSearchParams(frag);
            return params.get(param);
        }();
        if (where === "query") return queryVal;
        if (where === "fragment") return fragmentVal;
        return queryVal !== null && queryVal !== void 0 ? queryVal : fragmentVal;
    } catch (_a) {
        return this.getParamFromRaw(raw, param, where);
    }
}
_$commonHelper_8.getQueryParamFromRawUrl = getQueryParamFromRawUrl;
function getCancelRedirectUri() {
    var _a, _b, _c, _d, _e;
    var key = 'cancel_redirect_uri';
    var hrefUrl = new URL(window.location.href);
    var uri = hrefUrl.searchParams.get(key);
    if (uri) return uri;
    var authorizeParams = (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem("sa_authorize_params");
    if (authorizeParams) {
        var cancelUri = getQueryParamFromRaw(authorizeParams, key);
        if (cancelUri) {
            return cancelUri;
        }
    }
    var cancelRedirectUri = (_b = window.sessionStorage) === null || _b === void 0 ? void 0 : _b.getItem(key);
    if (cancelRedirectUri) {
        deduplicateCancelRedirectUri();
        return (_c = window.sessionStorage) === null || _c === void 0 ? void 0 : _c.getItem(key);
    }
    var isRedirectedURi = (_d = window.localStorage) === null || _d === void 0 ? void 0 : _d.getItem("is_redirected");
    if (isRedirectedURi) {
        var url = new URL(isRedirectedURi);
        uri = url.searchParams.get(key);
        if (uri) return uri;
    }
    var remoteResource = (_e = window.SETTINGS) === null || _e === void 0 ? void 0 : _e.remoteResource;
    if (remoteResource) {
        var url = new URL(remoteResource);
        uri = url.searchParams.get(key);
        if (uri) return uri;
    }
    return "";
}
_$commonHelper_8.getCancelRedirectUri = getCancelRedirectUri;
function deduplicateCancelRedirectUri() {
    var key = 'cancel_redirect_uri';
    var value = window.sessionStorage.getItem(key);
    if (value) {
        var uniqueUris = Array.from(new Set(value.split(',').map(function (uri) {
            return uri.trim();
        }).filter(function (uri) {
            return uri.length > 0;
        })));
        var newValue = uniqueUris.join(',');
        if (newValue !== value) {
            window.sessionStorage.setItem(key, newValue);
        }
    }
}

var _$onetrustHelper_9 = {};
"use strict";

Object.defineProperty(_$onetrustHelper_9, "__esModule", { value: true });
_$onetrustHelper_9.getOneTrustViewCookieSettingsLinkText = void 0;
var getOneTrustViewCookieSettingsLinkText = function getOneTrustViewCookieSettingsLinkText() {
    var _a, _b;
    var fnGetDomainData = (_b = (_a = window.OneTrust) === null || _a === void 0 ? void 0 : _a.GetDomainData) !== null && _b !== void 0 ? _b : null;
    var viewCookieSettingsText = !fnGetDomainData || typeof fnGetDomainData !== "function" ? null : fnGetDomainData().AlertMoreInfoText;
    return viewCookieSettingsText;
};
_$onetrustHelper_9.getOneTrustViewCookieSettingsLinkText = getOneTrustViewCookieSettingsLinkText;

var _$sessionStorageUtility_6 = {};
"use strict";

Object.defineProperty(_$sessionStorageUtility_6, "__esModule", { value: true });
_$sessionStorageUtility_6.SessionStorageUtility = void 0;
var SessionStorageUtility = function () {
    function SessionStorageUtility() {}
    SessionStorageUtility.prototype.Retrieve = function (key) {
        var _a;
        return (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem(key);
    };
    SessionStorageUtility.prototype.Save = function (item) {
        var _a;
        (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.setItem(item.key, item.val);
    };
    SessionStorageUtility.prototype.Clear = function (keys) {
        var _a;
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.removeItem(key);
        }
    };
    return SessionStorageUtility;
}();
_$sessionStorageUtility_6.SessionStorageUtility = SessionStorageUtility;

var _$browserContextUtility_5 = {};
"use strict";

Object.defineProperty(_$browserContextUtility_5, "__esModule", { value: true });
_$browserContextUtility_5.BrowserContextUtility = void 0;
/* removed: var _$environment_2 = require("../../../../../environments/environment"); */;
/* removed: var _$domainEnum_7 = require("../../../../enums/domain.enum"); */;
/* removed: var _$commonHelper_8 = require("../../../../helpers/common.helper"); */;
/* removed: var _$sessionStorageUtility_6 = require("./session-storage.utility"); */;
var CULTURE_CODE_KEY = 'cultureCode';
var CLIENT_COUNTRY_CODE_KEY = 'clientCountry';
var CLIENT_COUNTRY_ID_KEY = 'clientCountryId';
var CANCEL_REDIRECT_URI_KEY = 'cancel_redirect_uri';
var HIDE_REQUEST_KEY = 'hide_request_help';
var BrowserContextUtility = function () {
    function BrowserContextUtility() {
        this.urlHasParams = window.location.href.indexOf('?') > 0;
        this.storageSvc = new _$sessionStorageUtility_6.SessionStorageUtility();
    }
    BrowserContextUtility.prototype.GetCultureCode = function () {
        var _a, _b, _c, _d, _e;
        var language = this.urlHasParams ? this.tryGetValueFromQueryString(['cultureCode', 'ui_locales']) : this.tryGetValueFromRemoteResource(['cultureCode', 'ui_locales']);
        language = this.normalizeCultureCode(language);
        if (this.isFiveCharCultureCode(language)) {
            return this.setAndYield(CULTURE_CODE_KEY, language);
        }
        var currentDomain = (0, _$commonHelper_8.getCurrentDomain)();
        switch (currentDomain) {
            case _$domainEnum_7.Domain.B2C:
                {
                    var locale = (_a = window.SETTINGS) === null || _a === void 0 ? void 0 : _a.locale;
                    if (locale) {
                        var b2cLocale = this.normalizeCultureCode("".concat(locale.lang, "-").concat(locale.country));
                        if (this.isFiveCharCultureCode(b2cLocale)) {
                            return this.setAndYield(CULTURE_CODE_KEY, b2cLocale);
                        }
                    }
                    break;
                }
            case _$domainEnum_7.Domain.Main:
                var dnnLanguage = this.normalizeCultureCode((_d = (_c = (_b = window.TemplateHeaderWidget) === null || _b === void 0 ? void 0 : _b.Language) === null || _c === void 0 ? void 0 : _c.CurrentLanguage) !== null && _d !== void 0 ? _d : sessionStorage.getItem('cultureCode'));
                if (this.isFiveCharCultureCode(dnnLanguage)) {
                    return this.setAndYield(CULTURE_CODE_KEY, dnnLanguage);
                }
                break;
            case _$domainEnum_7.Domain.Registration:
                if (window.location.href.toLocaleLowerCase().indexOf("/notices/") > -1) {
                    var lastSegment = this.normalizeCultureCode(this.getCultureCodeByLastUrlSegment());
                    if (this.isFiveCharCultureCode(lastSegment)) {
                        return this.setAndYield(CULTURE_CODE_KEY, lastSegment);
                    }
                }
                break;
            default:
                break;
        }
        var browserLang = this.normalizeCultureCode(this.getBrowserLangOrDefault());
        if (this.isFiveCharCultureCode(browserLang)) {
            return this.setAndYield(CULTURE_CODE_KEY, browserLang);
        }
        var remoteDefaultCultureCode = this.normalizeCultureCode((0, _$commonHelper_8.getQueryParam)('defaultCultureCode', (_e = window.SETTINGS) === null || _e === void 0 ? void 0 : _e.remoteResource));
        if (this.isFiveCharCultureCode(remoteDefaultCultureCode)) {
            return this.setAndYield(CULTURE_CODE_KEY, remoteDefaultCultureCode);
        }
        var clientCountryDefaultCultureCode = this.normalizeCultureCode(this.getDefaultCultureCodeByClientCountry());
        if (this.isFiveCharCultureCode(clientCountryDefaultCultureCode)) {
            return this.setAndYield(CULTURE_CODE_KEY, clientCountryDefaultCultureCode);
        }
        var strictDefault = this.isFiveCharCultureCode(_$environment_2.environment.defaultCultureCode) ? _$environment_2.environment.defaultCultureCode : 'en-US';
        return this.setAndYield(CULTURE_CODE_KEY, strictDefault);
    };
    BrowserContextUtility.prototype.isFiveCharCultureCode = function (code) {
        var normalizedCode = this.normalizeCultureCode(code);
        var fiveCharCultureCodeRegEx = new RegExp(/^[a-zA-Z]{2}-[a-zA-Z]{2}$/);
        return fiveCharCultureCodeRegEx.test(normalizedCode || "");
    };
    BrowserContextUtility.prototype.normalizeCultureCode = function (code) {
        if (!code) return "";
        var normalized = code.trim();
        if (normalized.toLocaleLowerCase() == 'zh-hant') return 'zh-HK';
        if (normalized.toLocaleLowerCase() == 'zh-hans') return 'zh-CN';
        return normalized;
    };
    BrowserContextUtility.prototype.GetClientCountryId = function () {
        var _a;
        var ccid = null;
        ccid = this.urlHasParams ? this.tryGetValueFromQueryString(['clientCountry', 'clientCountryId']) : this.tryGetValueFromRemoteResource(['clientCountry', 'clientCountryId']);
        if (ccid) {
            return this.setAndYield(CLIENT_COUNTRY_CODE_KEY, ccid);
        }
        var storedCode = (_a = this.storageSvc.Retrieve(CLIENT_COUNTRY_CODE_KEY)) !== null && _a !== void 0 ? _a : this.storageSvc.Retrieve(CLIENT_COUNTRY_ID_KEY);
        if (storedCode) {
            return storedCode;
        }
        return null;
    };
    BrowserContextUtility.prototype.GetHideRequestHelp = function () {
        var ccid = null;
        ccid = this.urlHasParams ? this.tryGetValueFromQueryString(['hide_request_help']) : this.tryGetValueFromRemoteResource(['hide_request_help']);
        if (ccid) {
            return this.setAndYield(HIDE_REQUEST_KEY, ccid);
        }
        var storedCode = this.storageSvc.Retrieve(HIDE_REQUEST_KEY);
        if (storedCode) {
            return storedCode;
        }
        return null;
    };
    BrowserContextUtility.prototype.GetCancelRedirectUri = function () {
        var _a;
        var uri = null;
        if (this.urlHasParams) {
            uri = this.tryGetValueFromQueryString([CANCEL_REDIRECT_URI_KEY]);
            if (uri) {
                return this.setAndYield(CANCEL_REDIRECT_URI_KEY, uri);
            }
        }
        if (window && window.SETTINGS) {
            var cancelRedirectUrl = (0, _$commonHelper_8.getQueryParam)(CANCEL_REDIRECT_URI_KEY, (_a = window.SETTINGS) === null || _a === void 0 ? void 0 : _a.remoteResource);
            if (cancelRedirectUrl) {
                return this.setAndYield(CANCEL_REDIRECT_URI_KEY, cancelRedirectUrl);
            }
        }
        var storedCode = this.storageSvc.Retrieve(CANCEL_REDIRECT_URI_KEY);
        if (storedCode) {
            return storedCode;
        }
        return null;
    };
    BrowserContextUtility.prototype.setAndYield = function (key, val) {
        this.storageSvc.Save({ key: key, val: val });
        return val;
    };
    BrowserContextUtility.prototype.tryGetValueFromQueryString = function (possibleParams) {
        for (var _i = 0, possibleParams_1 = possibleParams; _i < possibleParams_1.length; _i++) {
            var param = possibleParams_1[_i];
            var queryValue = (0, _$commonHelper_8.getQueryParam)(param);
            if (!!queryValue) return queryValue;
        }
        return "";
    };
    BrowserContextUtility.prototype.tryGetValueFromRemoteResource = function (possibleParams) {
        var _a;
        for (var _i = 0, possibleParams_2 = possibleParams; _i < possibleParams_2.length; _i++) {
            var param = possibleParams_2[_i];
            var queryValue = (0, _$commonHelper_8.getQueryParam)(param, (_a = window.SETTINGS) === null || _a === void 0 ? void 0 : _a.remoteResource);
            if (!!queryValue) return queryValue;
        }
        return "";
    };
    BrowserContextUtility.prototype.isValidCode = function (code) {
        var codeRegEx = new RegExp(/^[a-zA-Z]{1,8}(?:-[a-zA-Z0-9]{1,8})*$/);
        return codeRegEx.test(code || "");
    };
    BrowserContextUtility.prototype.getBrowserLangOrDefault = function () {
        if (window.navigator) {
            var browserLang = window.navigator.language.trim().toLowerCase();
            if (browserLang) return browserLang;
        }
        return _$environment_2.environment.defaultCultureCode;
    };
    BrowserContextUtility.prototype.getDefaultCultureCodeByClientCountry = function () {
        var _a;
        var cachedCultureCode = this.normalizeCultureCode(this.storageSvc.Retrieve(CULTURE_CODE_KEY));
        if (this.isFiveCharCultureCode(cachedCultureCode)) {
            return cachedCultureCode;
        }
        var clientCountryId = this.GetClientCountryId();
        var registrationApiUrl = _$environment_2.environment.registrationApi;
        if (!clientCountryId || !registrationApiUrl || typeof registrationApiUrl !== 'string') {
            return "";
        }
        var requestUrl = "".concat(registrationApiUrl, "/Localization/GetDefaultCultureCodeByClientCountry?clientCountryId=").concat(encodeURIComponent(clientCountryId));
        try {
            var request = new XMLHttpRequest();
            request.open('GET', requestUrl, false);
            request.setRequestHeader('Content-Type', 'application/json');
            request.send();
            if (request.status >= 200 && request.status < 300) {
                var responseText = (_a = request.responseText) === null || _a === void 0 ? void 0 : _a.trim();
                if (!responseText) return "";
                try {
                    var parsedResponse = JSON.parse(responseText);
                    if (typeof parsedResponse === 'string') {
                        this.storageSvc.Save({ key: CULTURE_CODE_KEY, val: parsedResponse });
                        return parsedResponse;
                    }
                    if (parsedResponse && typeof parsedResponse.cultureCode === 'string') {
                        this.storageSvc.Save({ key: CULTURE_CODE_KEY, val: parsedResponse.cultureCode });
                        return parsedResponse.cultureCode;
                    }
                    return "";
                } catch (_b) {
                    this.storageSvc.Save({ key: CULTURE_CODE_KEY, val: responseText });
                    return responseText;
                }
            }
        } catch (_c) {
            return "";
        }
        return "";
    };
    BrowserContextUtility.prototype.getCultureCodeByLastUrlSegment = function () {
        var _a;
        var lastSegment = (_a = window.location.href.split('/').pop()) !== null && _a !== void 0 ? _a : "";
        var questionMarkIndex = lastSegment.indexOf("?");
        lastSegment = lastSegment.substring(0, questionMarkIndex < 0 ? undefined : questionMarkIndex);
        var codeIsValid = this.isValidCode(lastSegment);
        return codeIsValid ? lastSegment : "";
    };
    return BrowserContextUtility;
}();
_$browserContextUtility_5.BrowserContextUtility = BrowserContextUtility;

var _$cookiebanner_4 = {};
"use strict";

var __spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(_$cookiebanner_4, "__esModule", { value: true });
_$cookiebanner_4.CookieBanner = void 0;
/* removed: var _$environment_2 = require("../../../../environments/environment"); */;
/* removed: var _$commonHelper_8 = require("../../../helpers/common.helper"); */;
/* removed: var _$onetrustHelper_9 = require("../../../helpers/onetrust.helper"); */;
/* removed: var _$browserContextUtility_5 = require("../services/utilities/browser-context.utility"); */;
var applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
var ViewCookieSettingsStatus;
(function (ViewCookieSettingsStatus) {
    ViewCookieSettingsStatus[ViewCookieSettingsStatus["Loading"] = 0] = "Loading";
    ViewCookieSettingsStatus[ViewCookieSettingsStatus["Enabled"] = 1] = "Enabled";
    ViewCookieSettingsStatus[ViewCookieSettingsStatus["Disabled"] = 2] = "Disabled";
})(ViewCookieSettingsStatus || (ViewCookieSettingsStatus = {}));
var CookieBanner = function () {
    function CookieBanner() {
        this.cookieBannerSettings = {
            verboseLogging: _$environment_2.environment.cookieBannerSettings.verboseLogging,
            oneTrustCheckerIntervalInSeconds: _$environment_2.environment.cookieBannerSettings.oneTrustCheckerIntervalInSeconds
        };
        this.oneTrustLanguagesTriedIndex = -1;
        this._oneTrustLanguagesToTryToLoad = null;
        if (!this.applicationId) {
            this.setViewCookieSettingsLink(ViewCookieSettingsStatus.Disabled);
            console.error('Initialization Error: No applicationId provided for banner script');
            return;
        }
        if (this.cookieBannerSettings.verboseLogging) console.debug("AppId for OneTrust", this.applicationId);
        this.setViewCookieSettingsLink(ViewCookieSettingsStatus.Loading);
        this.loadOneTrustScripts();
        this.initializeOneTrustCheckerInterval();
        this.enableAppInsightsCookieBanner();
    }
    CookieBanner.prototype.enableAppInsightsCookieBanner = function () {
        var config = _$environment_2.environment.appInsightsConfig;
        window["AppInsightsCookieBanner"] = new applicationinsights_web_1.ApplicationInsights({ config: config });
    };
    Object.defineProperty(CookieBanner.prototype, "applicationId", {
        get: function get() {
            var _a;
            if (!this._applicationId) {
                var curDomain = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
                console.debug("detected domain: ".concat(curDomain));
                var appId = "";
                switch (curDomain) {
                    case 'login-embark.ehr.com':
                        appId = '019d29e0-372e-7a53-8f0a-b5d12665a7fe';
                        break;
                    case 'signin-embark.ehr.com':
                    case 'signin-embark-uat.ehr.com':
                        appId = '56da48b8-c13b-495e-bdd0-0e87fafc26c9';
                        break;
                    case 'n20projectexdnnprdstg.blob.core.windows.net':
                        appId = '019d29e0-372e-7a53-8f0a-b5d12665a7fe';
                        break;
                    case 'e20projectexdnnprdstg.blob.core.windows.net':
                    case 'n21projectexwdgtdevlogin.blob.core.windows.net':
                    case 'n21projectexdnnqastg.blob.core.windows.net':
                        appId = '28ddd5c1-3eba-4b29-ae4d-d1e247dc4633';
                        break;
                    case 'embark.ehr.com':
                    case 'embark2.ehr.com':
                    case 'embark-uat.ehr.com':
                    case 'embark2-uat.ehr.com':
                    case 'embark3-uat.ehr.com':
                    case 'embark3.ehr.com':
                        appId = '732a960c-ec94-4992-ab25-085d34ac38f8';
                        break;
                    case 'auth.ehr.com':
                        appId = '019d29e0-372e-7a53-8f0a-b5d12665a7fe';
                        break;
                    case 'auth-2.ehr.com':
                    case 'auth-2-uat.ehr.com':
                        appId = 'c881b241-6f27-47c9-b147-f6d7c93e8e6d';
                        break;
                    case 'auth-dev.ehr.com':
                        appId = 'c881b241-6f27-47c9-b147-f6d7c93e8e6d';
                        break;
                    case 'wtwexregistrationapp.azurewebsites.net':
                    case 'n21pexregistrationuidevappsvc.azurewebsites.net':
                    case 'signin-embark-lpt.ehr.com':
                    case 'signin-embark-qa.ehr.com':
                    case 'signin-embark-dev.ehr.com':
                        appId = '56da48b8-c13b-495e-bdd0-0e87fafc26c9';
                        break;
                    case 'n21projectexdnndevappsvc.azurewebsites.net':
                    case 'n21projectexdnnqaappsvc.azurewebsites.net':
                    case 'n21projectexdnnlptappsvc.azurewebsites.net':
                    case 'embark-qa.ehr.com':
                    case 'embark-lpt.ehr.com':
                    case 'embark2-qa.ehr.com':
                    case 'n21pexrootconfigmicrofrontenddevappsvc.azurewebsites.net':
                    case 'embark3-lpt.ehr.com':
                    case 'embark3-qa.ehr.com':
                    case 'embark-dev.ehr.com':
                        appId = '732a960c-ec94-4992-ab25-085d34ac38f8';
                        break;
                    default:
                        appId = "";
                        break;
                }
                globalThis.environmentUseTestScripts = _$environment_2.environment.useTestScripts;
                if (_$environment_2.environment.useTestScripts && appId) {
                    appId += '-test';
                }
                this._applicationId = appId;
            }
            return this._applicationId;
        },
        enumerable: false,
        configurable: true
    });
    CookieBanner.prototype.initializeOneTrustCheckerInterval = function () {
        var _this = this;
        var oneTrustLanguagesCount = this.oneTrustLanguagesToTryToLoad.length;
        var oneTrustLanaguagesIndex = 1;
        var oneTrustCheckerInterval = setInterval(function () {
            var _a;
            if ((_a = window.OneTrust) === null || _a === void 0 ? void 0 : _a.LoadBanner) {
                clearInterval(oneTrustCheckerInterval);
                _this.setViewCookieSettingsLink(ViewCookieSettingsStatus.Enabled);
                _this.hideStrictCookieToggle();
                console.debug("Successfully loaded OneTrust in ".concat(_this.getCurrentOneTrustLanguage()));
            } else {
                console.warn("".concat(_this.getCurrentOneTrustLanguage(), " in OneTrust does not exist after waiting for ").concat(_this.cookieBannerSettings.oneTrustCheckerIntervalInSeconds, " seconds"));
                if (oneTrustLanaguagesIndex === oneTrustLanguagesCount) {
                    _this.setViewCookieSettingsLink(ViewCookieSettingsStatus.Disabled);
                    clearInterval(oneTrustCheckerInterval);
                    console.warn("Stopping OneTrust checker script");
                } else {
                    _this.loadOneTrustScripts();
                }
                oneTrustLanaguagesIndex++;
            }
        }, this.cookieBannerSettings.oneTrustCheckerIntervalInSeconds * 1000);
    };
    Object.defineProperty(CookieBanner.prototype, "oneTrustLanguagesToTryToLoad", {
        get: function get() {
            var _a;
            if (!this._oneTrustLanguagesToTryToLoad) {
                var languagesToTry = [];
                var langCode = (_a = new _$browserContextUtility_5.BrowserContextUtility().GetCultureCode()) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
                if (langCode) {
                    languagesToTry = [langCode, langCode.split('-')[0]];
                }
                languagesToTry = __spreadArray(__spreadArray([], languagesToTry, true), [_$environment_2.environment.oneTrust.defaultLanguage], false);
                languagesToTry = languagesToTry.filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                });
                this._oneTrustLanguagesToTryToLoad = languagesToTry;
            }
            return this._oneTrustLanguagesToTryToLoad;
        },
        enumerable: false,
        configurable: true
    });
    CookieBanner.prototype.getOneTrustLanguageToLoad = function () {
        this.oneTrustLanguagesTriedIndex++;
        return this.getCurrentOneTrustLanguage();
    };
    CookieBanner.prototype.getCurrentOneTrustLanguage = function () {
        return this.oneTrustLanguagesToTryToLoad[this.oneTrustLanguagesTriedIndex];
    };
    CookieBanner.prototype.getCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };
    CookieBanner.prototype.parseJwt = function (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    };
    ;
    CookieBanner.prototype.loadOneTrustScripts = function () {
        var scriptLanguage = this.getOneTrustLanguageToLoad();
        if (!!!scriptLanguage) return;
        var that = this;
        console.debug("Loading OneTrust in ".concat(scriptLanguage, "..."));
        that.removeAllOneTrustScript();
        try {
            var token = this.getCookie('OneTrustToken');
            if (token) {
                var decoded = this.parseJwt(token);
                if (decoded.sub) {
                    var scriptOneTrust = document.createElement("script");
                    scriptOneTrust.type = "text/javascript";
                    scriptOneTrust.text = "var OneTrust = {dataSubjectParams: {id: \"".concat(decoded.sub, "\", isAnonymous: false, token: \"").concat(token, "\" }}");
                    document.head.appendChild(scriptOneTrust);
                    $("<script />", {
                        "type": "text/javascript",
                        "data-language": scriptLanguage,
                        "data-domain-script": "".concat(this.applicationId),
                        "charset": "UTF-8",
                        "src": "https://cdn.cookielaw.org/consent/".concat(this.applicationId, "/otSDKStub.js")
                    }).appendTo("head");
                    if (!$('#optanon-helpers-script').length) {
                        $("<script />", {
                            "id": "optanon-helpers-script",
                            "src": "".concat(_$environment_2.environment.storageAccountUrl).concat(_$environment_2.environment.storageContainer, "/js/optanon-helpers.js")
                        }).appendTo("head");
                    }
                }
            } else {
                $("<script />", {
                    "id": "cookie-banner-script",
                    "data-language": scriptLanguage,
                    "data-domain-script": that.applicationId,
                    "charset": "UTF-8",
                    "src": _$environment_2.environment.oneTrust.cookieBannerScriptSrc
                }).on("load", function () {
                    if (that.cookieBannerSettings.verboseLogging) console.debug("cookie-banner-script: bannerScript loaded");
                }).on("error", function () {
                    if (that.cookieBannerSettings.verboseLogging) console.debug("cookie-banner-script: bannerScript has an error");
                }).appendTo("head");
                if (that.cookieBannerSettings.verboseLogging) console.debug("loadOneTrustScripts: cookie-banner-script reloaded.");
                if (!$('#optanon-helpers-script').length) {
                    $("<script />", {
                        "id": "optanon-helpers-script",
                        "src": "".concat(_$environment_2.environment.storageAccountUrl).concat(_$environment_2.environment.storageContainer, "/js/optanon-helpers.js")
                    }).appendTo("head");
                }
            }
        } catch (e) {
            console.debug('OneTrustToken error');
        }
    };
    CookieBanner.prototype.setViewCookieSettingsLink = function (status) {
        var fnGetViewCookieSettingsLink = function fnGetViewCookieSettingsLink() {
            return $(".ot-sdk-show-settings");
        };
        var fnSetLink = function fnSetLink() {
            viewCookieSettingsLink = fnGetViewCookieSettingsLink();
            if (!viewCookieSettingsLink.length) return;
            switch (status) {
                case ViewCookieSettingsStatus.Loading:
                    viewCookieSettingsLink.attr("style", "opacity: .65; cursor: progress; color: black !important; text-decoration: none !important");
                    viewCookieSettingsLink.attr("data-onclick", viewCookieSettingsLink.attr("onclick"));
                    viewCookieSettingsLink.removeAttr("onclick");
                    break;
                case ViewCookieSettingsStatus.Enabled:
                    var viewCookieSettingsText = (0, _$onetrustHelper_9.getOneTrustViewCookieSettingsLinkText)();
                    if (viewCookieSettingsText) viewCookieSettingsLink.text(viewCookieSettingsText);
                    viewCookieSettingsLink.attr("onclick", viewCookieSettingsLink.attr("data-onclick"));
                    viewCookieSettingsLink.removeAttr("data-onclick");
                    viewCookieSettingsLink.removeAttr("style");
                    break;
                default:
                    viewCookieSettingsLink.removeAttr("onclick");
                    viewCookieSettingsLink.removeAttr("data-onclick");
                    viewCookieSettingsLink.attr("style", "opacity: .65; cursor: not-allowed; color: black !important; text-decoration: none !important");
                    break;
            }
            viewCookieSettingsLink.height();
        };
        var viewCookieSettingsLink = fnGetViewCookieSettingsLink();
        if (viewCookieSettingsLink.length) {
            fnSetLink();
        } else {
            (0, _$commonHelper_8.waitForElementToLoad)(".ot-sdk-show-settings", fnSetLink);
        }
    };
    CookieBanner.prototype.hideStrictCookieToggle = function () {
        (0, _$commonHelper_8.waitForElementToLoad)("#cookie-preferences > .ot-always-active-group > .ot-switch.ot-toggle", function (foundElement) {
            if (!foundElement.hasClass("ot-hide-tgl")) {
                foundElement.addClass("ot-hide-tgl");
                foundElement.attr("data-code-override", "set to hidden");
            }
        });
    };
    CookieBanner.prototype.removeAllOneTrustScript = function () {
        var location = this.getAnchorFromString(_$environment_2.environment.oneTrust.cookieBannerScriptSrc);
        var onetrustDomain = location.hostname.replace('www.', '');
        $("script[src*='".concat(onetrustDomain, "']")).remove();
    };
    CookieBanner.prototype.getAnchorFromString = function (url) {
        var location = document.createElement("a");
        location.href = url;
        if (location.host == "") {
            location.href = location.href;
        }
        return location;
    };
    return CookieBanner;
}();
_$cookiebanner_4.CookieBanner = CookieBanner;
try {
    if (window.self == window.top) {
        var jqueryCheckerInterval_1 = setInterval(function () {
            if (window.jQuery && $('body').is(':visible')) {
                clearInterval(jqueryCheckerInterval_1);
                window.CookieBanner = new CookieBanner();
            }
        }, 100);
    }
} catch (error) {
    console.error("Error occurred while loading CookieBanner", error);
}

}());